const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

const {Icon} = require('ui-library');
const _ = require('lodash');
const i18n = require('../../../../i18n');

const SearchFilter = require('./search-filter');

module.exports = createClass({
  displayName: 'Search',

  propTypes: {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    filters: PropTypes.object,
    onChangeFilter: PropTypes.func,
    className: PropTypes.string
  },

  getDefaultProps() {
    return {
      filters: null,
      value: ''
    };
  },

  getInitialState() {
    return {
      filters: this.props.filters
    };
  },

  _onFilterClick(group, selected) {
    const {filters} = this.state;
    const optionGroup = _.get(filters, group);
    const {onChangeFilter} = this.props;
    let index;

    if (_.isFunction(optionGroup.indexOf)) {
      index = optionGroup.indexOf(selected);
      optionGroup[index].checked = !optionGroup[index].checked;
    } else {
      optionGroup.checked = !optionGroup.checked;
    }

    filters[group] = optionGroup;
    this.setState({filters: filters});

    if (_.isFunction(onChangeFilter)) onChangeFilter(filters);
  },

  render() {
    const {
      value,
      onChange,
      className,
      placeholder = i18n.get('SEARCH_PLACEHOLDER')
    } = this.props;
    const {filters} = this.state;
    let classes = 'vf-search';

    if (className) classes += ' ' + className;

    return (
      <div className={classes}>
        <input type='text' value={value} onChange={onChange} placeholder={placeholder}/>
        <Icon icon='search' />
        {filters ? (<SearchFilter onChange={this._onFilterClick} filters={filters} />) : null}
      </div>
    );
  }
});
